// ============================================================================
// GERMAN BIBLE PASSAGES - Luther 1984
// ============================================================================
// Deutsche Bibelpassagen mit Strong-Referenzen

export const biblePassagesDe = {
  "Genesis_1": {
    book: "1. Mose",
    chapter: 1,
    title: "Die Schöpfung der Welt",
    verses: [
      { number: 1, text: "Am Anfang schuf Gott Himmel und Erde.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "Und die Erde war wüst und leer, und es war finster auf der Tiefe; und der Geist Gottes schwebte auf dem Wasser.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Und Gott sprach: Es werde Licht! Und es ward Licht.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "Und Gott sah, dass das Licht gut war. Da schied Gott das Licht von der Finsternis.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Und nannte das Licht Tag und die Finsternis Nacht. Da ward aus Abend und Morgen der erste Tag.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "Und Gott sprach: Es werde eine Feste zwischen den Wassern, die da scheide zwischen den Wassern.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "Da machte Gott die Feste und schied das Wasser unter der Feste von dem Wasser über der Feste. Und es geschah so.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "Und Gott nannte die Feste Himmel. Da ward aus Abend und Morgen der zweite Tag.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Und Gott schuf den Menschen zu seinem Bilde, zum Bilde Gottes schuf er ihn; und schuf sie als Mann und Frau.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Und Gott sah an alles, was er gemacht hatte, und siehe, es war sehr gut. Da ward aus Abend und Morgen der sechste Tag.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Psalm_23": {
    book: "Psalmen",
    chapter: 23,
    title: "Der HERR ist mein Hirte",
    verses: [
      { number: 1, text: "Der HERR ist mein Hirte, mir wird nichts mangeln.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Er weidet mich auf einer grünen Aue und führet mich zum frischen Wasser.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Er erquicket meine Seele. Er führet mich auf rechter Straße um seines Namens willen.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Und ob ich schon wanderte im finstern Tal, fürchte ich kein Unglück; denn du bist bei mir, dein Stecken und Stab trösten mich.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Du bereitest vor mir einen Tisch im Angesicht meiner Feinde. Du salbest mein Haupt mit Öl und schenkest mir voll ein.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Gutes und Barmherzigkeit werden mir folgen mein Leben lang, und ich werde bleiben im Hause des HERRN immerdar.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Johannes_3": {
    book: "Johannes",
    chapter: 3,
    title: "Jesus und Nikodemus",
    verses: [
      { number: 16, text: "Denn also hat Gott die Welt geliebt, dass er seinen eingeborenen Sohn gab, damit alle, die an ihn glauben, nicht verloren werden, sondern das ewige Leben haben.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Denn Gott hat seinen Sohn nicht in die Welt gesandt, dass er die Welt richte, sondern dass die Welt durch ihn gerettet werde.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Wer an ihn glaubt, der wird nicht gerichtet; wer aber nicht glaubt, der ist schon gerichtet, denn er glaubt nicht an den Namen des eingeborenen Sohnes Gottes.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Philipper_4": {
    book: "Philipper",
    chapter: 4,
    title: "Der Friede Gottes",
    verses: [
      { number: 4, text: "Freuet euch in dem Herrn allewege, und abermals sage ich: Freuet euch!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Sorgt euch um nichts, sondern in allen Dingen lasst eure Bitten in Gebet und Flehen mit Danksagung vor Gott kundwerden!", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "Und der Friede Gottes, der höher ist als alle Vernunft, bewahre eure Herzen und Sinne in Christus Jesus.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Ich vermag alles durch den, der mich mächtig macht.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesDe;
